import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axios, errorResponse } from "../helpers";

const initialState = {
  data: {},
  isLogin: false,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const loginAction = createAsyncThunk("auth/login", async (form) => {
  try {
    const response = await axios.post("/v1/auth/login_web_admin", form);
    return response.data;
  } catch (err) {
    return errorResponse(err);
  }
});

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
  logout: (state) => {
    state.status = "idle";
    state.isLogin = false;
    state.data = {};
    localStorage.removeItem("token"); // hapus token
  },
  enterPage: (state) => {
    state.status = "idle";
    state.error = null;
  },
},

  extraReducers(builder) {
    builder.addCase(loginAction.pending, (state) => {
      state.status = "loading";
    });
   builder.addCase(loginAction.fulfilled, (state, action) => {
  if (action.payload.status) {
    state.status = "succeeded";
    state.isLogin = true;
    state.data = action.payload.data;
    state.error = null;

    // ⚡ Simpan token ke localStorage
    if (action.payload.data.token) {
      localStorage.setItem("token", action.payload.data.token);
    }
  } else {
    state.status = "failed";
    state.error = action.payload;
  }
});

    builder.addCase(loginAction.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    });
  },
});

export const loginData = (state) => state.login;
export const { logout, enterPage } = loginSlice.actions;

export default loginSlice.reducer;
